/** 기존 행의 서버 id 는 RHF fieldArray 의 id 와 별도로 보관한다. */
export interface SizeRowValues {
  readonly optionId?: string;
  readonly name: string;
}

export interface SizeFormValues {
  readonly sizeOptions: SizeRowValues[];
}

export const NEW_SIZE_ROW: SizeRowValues = { name: '' };
